(function () {
  if (window.onenessLiveStatusStarted) return;
  window.onenessLiveStatusStarted = true;
  const script = document.querySelector('script[data-ol-status-endpoint]');
  const endpoint = script?.dataset.olStatusEndpoint;
  let result = null;
  let running = false;
  let lastAttempt = 0;
  const channels = {plenty_hardaway:'UCAN3bL5wZPT0ifmtlw21-YQ',kicknology:'UCdm-ySW6NsRRqEkw-kScIAQ'};
  function twitchLogin(source) {
    try {
      const url = new URL(source);
      const login = url.pathname.split('/').filter(Boolean);
      return ['twitch.tv','www.twitch.tv','m.twitch.tv'].includes(url.hostname) && login.length === 1 && /^\w{1,25}$/.test(login[0]) ? login[0].toLowerCase() : null;
    } catch { return null; }
  }
  function videoId(source) {
    try {
      const url = new URL(source);
      if (!['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtu.be'].includes(url.hostname)) return null;
      const parts = url.pathname.split('/').filter(Boolean);
      const id = url.hostname.endsWith('youtu.be') ? parts[0] : parts[0] === 'watch' ? url.searchParams.get('v') : ['live','embed','shorts'].includes(parts[0]) ? parts[1] : null;
      return /^[\w-]{11}$/.test(id || '') ? id : null;
    } catch { return null; }
  }
  function apply() {
    const now = Date.now();
    const fresh = result?.version === 1 && Number.isFinite(result.checkedAt) && result.checkedAt <= now + 30000 && now - result.checkedAt < 300000 && result.expiresAt > now && Array.isArray(result.creators);
    const creators = fresh ? result.creators : [];
    document.documentElement.dataset.olNetworkLive = String(creators.some(item => item.status === 'live'));
    document.querySelectorAll('[data-ol-creator-id]').forEach(card => {
      const source = card.querySelector('[data-ol-watch]')?.dataset.source;
      const id = videoId(source);
      const login = twitchLogin(source);
      const match = creators.find(item => item.id === card.dataset.olCreatorId && ((login && item.platform === 'twitch' && item.login === login) || (id && (item.videoId === id || (channels[item.id] === item.channelId && /^[\w-]{11}$/.test(item.videoId))))));
      const status = match && ['live','offline','upcoming','unavailable'].includes(match.status) ? match.status : 'unknown';
      if (id && match && status !== 'unknown' && status !== 'unavailable' && match.videoId !== id && channels[match.id] === match.channelId) {
        const button = card.querySelector('[data-ol-watch]');
        if (button) {
          button.dataset.source = 'https://www.youtube.com/watch?v=' + match.videoId;
          const image = button.querySelector('img');
          if (image) image.src = 'https://i.ytimg.com/vi/' + match.videoId + '/hqdefault.jpg';
        }
      }
      if (card.dataset.olStatus !== status) {
        card.dataset.olStatus = status;
        card.closest('.ol')?.dispatchEvent(new CustomEvent('oneness:live-status'));
      }
    });
  }
  async function refresh() {
    apply();
    if (!endpoint || document.hidden || running || Date.now() - lastAttempt < 55000) return;
    running = true;
    lastAttempt = Date.now();
    try {
      const response = await fetch(endpoint,{credentials:'omit',signal:AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('Status unavailable');
      result = await response.json();
    } catch { result = null; }
    finally { running = false; apply(); }
  }
  document.addEventListener('shopify:section:load',apply);
  document.addEventListener('visibilitychange',refresh);
  window.addEventListener('pageshow',refresh);
  window.addEventListener('online',refresh);
  setInterval(refresh,60000);
  setInterval(apply,15000);
  refresh();
})();
